import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

import * as fromAuth from '../../core/actions/auth.actions';
import { AuthService } from '../../core/services/auth.service';

export function authInitFactory(
  authService: AuthService,
  store: Store,
): () => Promise<void> {
  return async () => {
    const credentials = authService.getCredentials();

    if (!credentials?.token) {
      store.dispatch(fromAuth.authCheck());
      return;
    }

    const remember = authService.getRememberMe();

    try {
      const response = await firstValueFrom(
        authService.verifyAuthToken(credentials.token),
      );
      if (response?.access_token) {
        store.dispatch(fromAuth.loginSuccess({ response, remember }));
      } else {
        store.dispatch(fromAuth.logout());
        store.dispatch(fromAuth.authCheck());
      }
    } catch {
      store.dispatch(fromAuth.logout());
      store.dispatch(fromAuth.authCheck());
    }
  };
}
